export default function validate(formProps) {
    const errors = {};

    if (!formProps.event_id) {
        errors.event_id = 'Event Id is required!';
    }

    if (
        !formProps.event_title ||
        (formProps.event_title && formProps.event_title === '')
    ) {
        errors.event_title = 'Event Title is required!';
    }

    if (
        !formProps.event_short_description ||
        (formProps.event_short_description &&
            formProps.event_short_description === '')
    ) {
        errors.event_short_description = 'Meta Description is required!';
    }

    if (!formProps.start_date) {
        errors.start_date =
            'When is required! Please select a date and time for the event!';
    }

    if (!formProps.sites || (formProps.sites && formProps.sites.length === 0)) {
        errors.sites = 'Please select at least 1 site!';
    }

    return errors;
}



// WEBPACK FOOTER //
// ./src/containers/webinars/forms/validation.js